import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LegalStatusView } from '@api-proxies';
import { LegalStatusService } from '@http/clients/legal-status.service';
import { ReportsService } from '@services/reports.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-legal-status-editor',
    templateUrl: './reporting-legal-status-editor.component.html',
    styleUrls: ['./reporting-legal-status-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class ReportingLegalStatusEditorComponent
    extends EditorComponentBase<number | null>
    implements OnInit, OnDestroy
{
    legalStatusItems?: LegalStatusView[];
    selectedLegalStatus?: LegalStatusView;
    subscription?: Subscription;
    constructor(
        private readonly legalStatusService: LegalStatusService,
        private reportsService: ReportsService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.legalStatusItems = await this.legalStatusService.getAll();

        if (this.bindingProperty !== null) {
            this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
                if (ready) {
                    this.selectedLegalStatus = this.foundItem();
                }
            });
        }
    }

    foundItem() {
        return this.legalStatusItems?.find((x) => x.id === this.bindingProperty);
    }

    onLegalStatusChange() {
        if (this.selectedLegalStatus?.id) {
            this.bindingProperty = this.selectedLegalStatus.id;
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
